import pino, { Logger } from 'pino';
import logLevelData from './logLevel';

const logLevels = new Map<string, string>(Object.entries(logLevelData));

export function getLogLevel(logger: string): string {
    const configLevel = process.env.LOG_LEVEL;
    if (configLevel) return configLevel.toLowerCase();
    return logLevels.get(logger) ?? logLevels.get('*') ?? 'info';
}

export function getLogger(name: string): Logger {
    return pino({
        name,
        level: getLogLevel(name)
    });
}
